var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-img',{attrs:{"contain":"","src":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }